import { useFormSchema } from "src/api/hooks/useFormSchema";

export const DateWidget = (props: any) => {
  const { value, onChange, label, required, id, uiSchema } = props;
  const dateValue = value ? new Date(value).toISOString().split("T")[0] : "";
  const { data: schema } = useFormSchema();
  const primaryColor = schema?.theme?.colors?.primary;

  return (
    <div className={`date-container container`}>
      <input
        type="date"
        className={`input-date`}
        value={dateValue}
        onChange={(e) => onChange(e.target.value || undefined)}
        required={required}
      />
    </div>
  );
};
